var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"panner",style:(_vm.style),on:{"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp,"mousemove":_vm.onMouseMove}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }